import {DrawFrmThing} from "../drawfrm/DrawFrmThing";
import {FrmRefPoint} from "../drawfrm/FrmRefPoint";
import {FrmShape} from "../drawfrm/FrmShape";
import {ElevationApp} from "../ElevationApp";
import {ChildView} from "./ChildView";

export class PairDoorGap extends DrawFrmThing {

    left!: FrmRefPoint;
    right!: FrmRefPoint;

    constructor(elev: ElevationApp, view: ChildView) {
        super();

        const pairDoorGap = elev.frameSpec.pairDoorGap


        FrmRefPoint.buildGroup(() => {
            this.left = new FrmRefPoint();
            this.right = new FrmRefPoint();
        });

        const shape = new FrmShape("doorGap", {
            dimensionMode: view.dimensionMode,
            thing: this,
            app: elev.draw,
        });
        shape.start(0, 0);
        shape.lineTo(pairDoorGap.get(), 0).setPenUp().linkDimension(pairDoorGap);

        this.left.setLocalPoint(shape.points[0]);
        this.right.setLocalPoint(shape.points[1]);

        shape.done();
    }
}